export function convertUtcToIst(date: string | Date | null | undefined): string {
  if (!date) return '';

  const utcDate =
    typeof date === 'string'
      ? new Date(date.endsWith('Z') ? date : date + 'Z')
      : new Date(date);

  return utcDate.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
}
